import React from 'react';
import Tooltip from './ui/Tooltip';
import { pillStyleVars } from '../extensions/bundled/task-manager/boardLabels';
import './boards/TaskLabelChips.css';

/**
 * A task's labels, as pills on a card, a list row or the chat share card.
 *
 * Pill = 6 px dot + name, 20 px tall, fully rounded, the label colour at 12 %
 * behind a light tint of it (Boards Redesign card 2.3). The colours come from
 * ONE helper, `pillStyleVars` in boardLabels.js, so the card, the row, the
 * filter chips and the Edit board preview cannot drift apart.
 *
 * Takes ALREADY-RESOLVED labels rather than a task plus a board: resolution
 * needs the board's palette, and threading a whole board object down to every
 * card just to look up three ids would re-render the entire grid whenever any
 * board field changed.
 *
 * Renders nothing when there are none — an empty label strip on every unlabelled
 * card is a row of whitespace that pushes the real content around for no reason.
 */
export default function TaskLabelChips({ labels, max = 3, className = '' }) {
  const list = labels || [];
  if (list.length === 0) return null;

  // Capped, with a count for the rest: labels are a scanning aid, and a card
  // wearing eight chips has stopped being scannable — the title disappears
  // under its own metadata.
  const shown = list.slice(0, max);
  const hidden = list.length - shown.length;

  return (
    <span className={`task-label-chips ${className}`.trim()}>
      {shown.map((l) => (
        <span key={l.id} className="task-label-chip" style={pillStyleVars(l)}>
          <span className="task-label-chip-dot" aria-hidden />
          <span className="task-label-chip-name">{l.name}</span>
        </span>
      ))}
      {hidden > 0 && (
        <Tooltip content={list.slice(max).map((l) => l.name).join(', ')} side="top">
          <span className="task-label-chip task-label-chip--more" aria-label={`${hidden} more: ${list.slice(max).map((l) => l.name).join(', ')}`}>
            +{hidden}
          </span>
        </Tooltip>
      )}
    </span>
  );
}
